export const NOVA_MICROSOFT_GRAPH_AUTHORIZATION_SESSION_KEY = 'nova-microsoft-graph-authorization';
export const NOVA_MICROSOFT_GRAPH_AUTHORIZATION_MESSAGE_TYPE = 'nova-microsoft-graph-authorization';
export const NOVA_MICROSOFT_GRAPH_AUTHORIZATION_RESULT_KEY = 'nova-microsoft-graph-authorization-result';
export const NOVA_MICROSOFT_GRAPH_AUTHORIZATION_POPUP_FEATURES =
  'popup=yes,width=600,height=720,menubar=no,toolbar=no,location=yes,status=no,scrollbars=yes,resizable=yes';

type MicrosoftGraphAuthorizationCallbackStatus = 'success' | 'error';

interface StoredMicrosoftGraphAuthorizationState {
  connectionUuid: string;
  expiresAt?: string;
  state: string;
}

export function readStoredMicrosoftGraphAuthorizationState(): StoredMicrosoftGraphAuthorizationState | null {
  try {
    // The opener stores the pending users-service connection before sending
    // this popup to Microsoft. localStorage is shared across same-origin
    // windows, which lets the callback recover the connection/state after the
    // cross-origin redirect back from login.microsoftonline.com.
    const stored = localStorage.getItem(NOVA_MICROSOFT_GRAPH_AUTHORIZATION_SESSION_KEY);
    return stored ? (JSON.parse(stored) as StoredMicrosoftGraphAuthorizationState) : null;
  } catch {
    return null;
  }
}

export function writeStoredMicrosoftGraphAuthorizationState(state: StoredMicrosoftGraphAuthorizationState): void {
  localStorage.setItem(NOVA_MICROSOFT_GRAPH_AUTHORIZATION_SESSION_KEY, JSON.stringify(state));
}

export function clearStoredMicrosoftGraphAuthorizationState(): void {
  localStorage.removeItem(NOVA_MICROSOFT_GRAPH_AUTHORIZATION_SESSION_KEY);
}

export function clearStoredMicrosoftGraphAuthorizationResult(): void {
  localStorage.removeItem(NOVA_MICROSOFT_GRAPH_AUTHORIZATION_RESULT_KEY);
}

export function returnMicrosoftGraphAuthorizationResultToMainWindow(
  status: MicrosoftGraphAuthorizationCallbackStatus,
  error?: unknown,
): void {
  // Persist the result before posting to the opener. The main window polls this
  // key as a fallback because postMessage can be missed if the popup closes
  // immediately after callback completion.
  localStorage.setItem(
    NOVA_MICROSOFT_GRAPH_AUTHORIZATION_RESULT_KEY,
    JSON.stringify({
      error: error instanceof Error ? error.message : undefined,
      status,
      timestamp: Date.now(),
    }),
  );

  // postMessage is the fast path when the opener is still alive. The opener
  // checks origin and message type before accepting the result.
  const hasOpener = Boolean(window.opener && !window.opener.closed);

  if (hasOpener) {
    window.opener.postMessage(
      {
        error: error instanceof Error ? error.message : undefined,
        status,
        type: NOVA_MICROSOFT_GRAPH_AUTHORIZATION_MESSAGE_TYPE,
      },
      window.location.origin,
    );
  }

  window.close();
}
